import { Button, Modal, Form, Col, Row } from 'react-bootstrap';
import UserService from '../../service/userService';
import UtilService from '../../service/utilService';
import { successNotify, errorNotify } from '../Utils/Toast';
import useToken from '../../App/useToken';
import React, { useState, useEffect } from 'react';

import './UserCreateModal.css'
const units = require('../../utils/Unit');
const unitSpcs = require('../../utils/UnitSpc');

export default function UserCreateModal({ showAddUsermModal, setShowAddUsermModal, getUser }) {
    const { getToken } = useToken();
    const token = getToken();
    const [role, setRole] = useState('adminViewer');
    const [email, setEmail] = useState();
    const [unit_no, setUnit] = useState('0');
    const [unitSpcNo, setUnitSpcNo] = useState('0');
    const [ranks, setRanks] = useState([]);
    const [isLoadingData, setIsLoadingData] = useState(false);
    const [rankAbbrName, setRankAbbrName] = useState('พล.อ.ท.');
    const [fullName, setFullName] = useState();
    const [password, setPassword] = useState();
    const [rtafEmail, setRtafEmail] = useState();
    

    useEffect(async () => {
      setIsLoadingData(true);
      const utilService = new UtilService();
      const rankRes = await utilService.getRank(token);
      if (rankRes?.length >= 0) setRanks(rankRes);
      setIsLoadingData(false);
    }, [])

    const handleClose = () => {
      setShowAddUsermModal(false);
    }

    const handleOnUserSave = async e => {
      e.preventDefault();
      const userService = new UserService();
      const res = await userService.createUser(token, { rankAbbrName, fullName, password, role, unit_no, unitSpcNo, email, rtafEmail });
      if (res.type != "error") {
        successNotify('แก้ไขข้อมูลสำเร็จ');
        getUser();
      } else {
        errorNotify(res?.message?.message || 'เกิดข้อผิดพลาด');
      }
      setShowAddUsermModal(false);
    }


    return (
      <>
        <Modal
            show={showAddUsermModal}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            centered
            size="lg"
          >
            { !isLoadingData && <Form onSubmit={handleOnUserSave}>
              <Modal.Header closeButton>
                <Modal.Title>เพิ่มผู้ดูแลระบบ</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col md={2}>
                    <Form.Group as={Col} >
                        <Form.Label>บทบาท	:</Form.Label>
                        <Form.Control
                            as="select"
                            onChange={e => { setRole(e.target.value)}}
                        >
                            <option value='adminViewer' >กพ.ทอ.(ReadOnly)</option>
                            <option value='adminUnitSpc' >หน่วย หน. สายวิทยาการ</option>
                            <option value='adminUnit' >นขต.ทอ.</option>
                        </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col md={2}>
                    <Form.Group as={Col} >
                        <Form.Label>ยศ :</Form.Label>
                        <Form.Control
                            as="select"
                            onChange={e => { setRankAbbrName(e.target.value)}}
                        >
                            {ranks.map((rank) => (
                                <option value={rank.name}>{rank.name}</option>
                            ))}
                        </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group as={Col} onChange={e => setFullName(e.target.value)}>
                      <Form.Label>ชื่อ - นามสกุล :</Form.Label>
                      <Form.Control required />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group as={Col} onChange={e => setEmail(e.target.value)}>
                      <Form.Label>ชื่อผู้ใช้ : {email}@rtaf.mi.th</Form.Label>
                      <Form.Control required />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={2}>
                    <Form.Group as={Col}>
                      <Form.Label>รหัสผ่าน	:</Form.Label>
                      <Form.Control required onChange={e => { setPassword(e.target.value)}} />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group as={Col}>
                      <Form.Label>อีเมล(RTAF)	:</Form.Label>
                      <Form.Control onChange={e => { setRtafEmail(e.target.value)}} />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group as={Col}>
                      <Form.Label>หน่วย	:</Form.Label>
                      <Form.Control
                            as="select"
                            onChange={e => { setUnit(e.target.value)}}
                        >
                            {units.map((unit) => (
                                <option value={unit.no}>{unit.name}</option>
                            ))}
                        </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group as={Col}>
                      <Form.Label>หน่วย หน. สายวิทยาการ	:</Form.Label>
                      <Form.Control
                            as="select"
                            onChange={e => { setUnitSpcNo(e.target.value)}}
                        >
                            {unitSpcs.map((spc) => (
                                <option value={spc.no}>{spc.name}</option>
                            ))}
                        </Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
                
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                  ปิด
                </Button>
                <Button variant="primary" type='submit'>บันทึก</Button>
              </Modal.Footer>
            </Form> }
        </Modal>
      </>
    );
}